var exports = {
  "JQ": "sponsorList__rU1jst",
  "OL": "sponsorItem__q29wHl",
  "GH": "sponsorName__6tlhz2",
  "Ye": "nameLink__E7saQa",
  "QC": "displayName__BBKIju",
  "v0": "fundingIcon__0jrCgT",
  "tV": "platformIcon__zZ8GuF",
  "XV": "fundingName__ydCtEL",
  "C2": "learnMore__-rCaCn",
  "V8": "sponsorButton__ZqD5GD",
};

module.exports = exports;
